import { atlas } from '~/services/serviceInstances';

import { ListPlaybookTemplatesResponse } from '../../types/playbooks/playbookTemplates';

export const getPlaybookTemplates =
  async (): Promise<ListPlaybookTemplatesResponse> => {
    return atlas.get('playbooks/templates');
  };
